import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ROUTE_PATH } from '@core/constants';
import { TvStartupService } from '@core/services/common';

@Injectable({
  providedIn: 'root'
})
export class TvStartupGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly tvStartupService: TvStartupService
  ) { }

  canActivate(_route: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    const redirectRoute = this.tvStartupService.getRedirectRoute(state.url);
    if (redirectRoute === ROUTE_PATH.TV_BLANK) {
      if (
        this.tvStartupService.isStartupCompleted()
        && this.tvStartupService.isStartupProtectedRoute(state.url)
      ) {
        return true;
      }

      return this.router.parseUrl(this.tvStartupService.getStartupUrl(state.url));
    }
    return redirectRoute ? this.router.parseUrl(`/${redirectRoute}`) : true;
  }
}
